import { jwtDecode } from "jwt-decode";

export function Middleware() {
    const token = localStorage.getItem("token");
    if (token == null) {
        window.location.href = '/';
        return;
    }
}

export function MiddlewareProvider() {
    const token = localStorage.getItem("token");
    const decode = jwtDecode(token)
    
    if (decode.role !== 3) {
        localStorage.removeItem("token");
        window.location.href = '/';
    }
}

export function MiddlewareInvitator() {
    const token = localStorage.getItem("token");
    const decode = jwtDecode(token)
    
    if (decode.role !== 2) {
        localStorage.removeItem("token");
        window.location.href = '/';
    }
}

export function MiddlewareAdmin() {
    const token = localStorage.getItem("token");
    const decode = jwtDecode(token)
    
    if (decode.role !== 1) {
        localStorage.removeItem("token");
        window.location.href = '/';
    }
}

export function MiddlewareSuperUser() {
    const token = localStorage.getItem("token");
    const decode = jwtDecode(token)
    
    if (decode.role !== 0) {
        localStorage.removeItem("token");
        window.location.href = '/';
    }
}